import { useEffect } from 'react';
import './App.css';
import { Analytics } from '@vercel/analytics/react';
import Header from './components/Header';
import About from './components/About';
import Resume from './components/Resume';
import Skills from './components/Skills';
import Services from './components/Services';
import HireMe from './components/HireMe';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { profile } from './data/profile';
import { experience } from './data/experience';
import { education } from './data/education';
import { skills } from './data/skills';
import { services } from './data/services';
import { projects } from './data/projects';

const CAREER_START_YEAR = Math.min(
  ...experience.map((e) => {
    const match = e.period.match(/\d{4}/);
    return match ? parseInt(match[0]) : new Date().getFullYear();
  })
);

function App() {
  useEffect(() => {
    const win = window as any;
    if (!win.$) return;
    const $ = win.$;

    const isMobile = {
      Android: () => navigator.userAgent.match(/Android/i),
      BlackBerry: () => navigator.userAgent.match(/BlackBerry/i),
      iOS: () => navigator.userAgent.match(/iPhone|iPad|iPod/i),
      Opera: () => navigator.userAgent.match(/Opera Mini/i),
      Windows: () => navigator.userAgent.match(/IEMobile/i),
      any: function() {
        return (this.Android() || this.BlackBerry() || this.iOS() || this.Opera() || this.Windows());
      }
    };

    // Full height
    if (!isMobile.any()) {
      $('.js-fullheight').css('height', $(window).height());
      $(window).resize(() => {
        $('.js-fullheight').css('height', $(window).height());
      });
    }

    // Parallax
    $(window).stellar();

    // Waypoints for animate-box
    $('.animate-box').waypoint(function(this: any, direction: string) {
      if (direction === 'down' && !$(this.element).hasClass('animated-fast')) {
        $(this.element).addClass('item-animate');
        setTimeout(() => {
          $('body .animate-box.item-animate').each(function(this: any, k: number) {
            const el = $(this);
            setTimeout(() => {
              const effect = el.data('animate-effect');
              if (effect === 'fadeIn') {
                el.addClass('fadeIn animated-fast');
              } else if (effect === 'fadeInLeft') {
                el.addClass('fadeInLeft animated-fast');
              } else if (effect === 'fadeInRight') {
                el.addClass('fadeInRight animated-fast');
              } else {
                el.addClass('fadeInUp animated-fast');
              }
              el.removeClass('item-animate');
            }, k * 100, 'easeInOutExpo');
          });
        }, 50);
      }
    }, { offset: '85%' });

    // Go to top
    $('.js-gotop').on('click', (event: Event) => {
      event.preventDefault();
      $('html, body').animate({ scrollTop: $('html').offset().top }, 500, 'easeInOutExpo');
      return false;
    });

    $(window).scroll(() => {
      if ($(window).scrollTop() > 200) {
        $('.js-top').addClass('active');
      } else {
        $('.js-top').removeClass('active');
      }
    });

    // Hide loader
    $('.fh5co-loader').fadeOut('slow');

    // Google Map: if Maps API already loaded (cached), initMap won't fire via callback — call it now
    if (win.google && win.google.maps && typeof win.initMap === 'function') {
      win.initMap();
    }
  }, []);

  return (
    <>
      <Analytics />
      <div className="fh5co-loader"></div>
      <div id="page">
        <Header profile={profile} />
        <About profile={profile} experienceStartYear={CAREER_START_YEAR} />
        <Resume experience={experience} education={education} />
        <Services services={services} />
        <Skills skills={skills} />
        <Projects projects={projects} />
        <HireMe experienceStartYear={CAREER_START_YEAR} />
        <Contact />
        <div id="map" className="fh5co-map"></div>
      </div>
      <Footer />
      <div className="gototop js-top">
        <a href="#top" className="js-gotop"><i className="icon-arrow-up22"></i></a>
      </div>
    </>
  );
}

export default App;
